import clsx from "clsx";
import { FC, ReactNode } from "react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation } from "swiper/modules";
import { Swiper } from "swiper/react";
import { UI } from "../../config/ui";
import { icSwiperNextArrow, icSwiperPrevArrow } from "../image/image-src";

export const SwiperWithArrow: FC<{
  onSlideChange?: (swiper: any) => void;
  children: ReactNode;
  spaceBetween?: number;
  centeredSlides?: boolean;
  className?: string;
  arrowClassName?: string;
  breakpoints?: any;
  slidesPerView?: any;
}> = ({
  onSlideChange,
  children,
  className,
  spaceBetween,
  centeredSlides,
  arrowClassName,
  breakpoints,
  slidesPerView = "auto",
}) => {
  return (
    <div className="relative">
      <Swiper
        modules={[Navigation]}
        onSlideChange={onSlideChange}
        spaceBetween={20}
        centeredSlides={centeredSlides}
        breakpoints={{
          [UI.sm]: {
            spaceBetween: spaceBetween ?? 40,
          },
          ...breakpoints,
        }}
        slidesPerView={slidesPerView}
        navigation={{
          nextEl: "#swiper-with-arrow--next",
          prevEl: "#swiper-with-arrow--prev",
        }}
        className={clsx(className)}
      >
        {children}
      </Swiper>
      <div
        className={clsx(
          "swiper-button-prev top-[50%] translate-y-[-50%]",
          arrowClassName,
        )}
        id="swiper-with-arrow--prev"
      >
        <img
          className="size-[0.625rem] sm:size-[0.875rem]"
          src={icSwiperPrevArrow}
          alt="Previous"
        />
      </div>
      <div
        className={clsx(
          "swiper-button-next top-[50%] translate-y-[-50%]",
          arrowClassName,
        )}
        id="swiper-with-arrow--next"
      >
        <img
          className="size-[0.625rem] sm:size-[0.875rem]"
          src={icSwiperNextArrow}
          alt="Next"
        />
      </div>
    </div>
  );
};
